import React from "react";
import { Button, Tag as AntTag, Space, Popconfirm, Tooltip } from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  FileImageOutlined,
  PlusOutlined,
  ReloadOutlined,
} from "@ant-design/icons";
import { ColumnsType } from "antd/es/table";
import type { ButtonConfig } from "@ms/shared-components";
import { Tag } from "../../../types/space";
import dayjs from "dayjs";

// 表格配置常量
export const TABLE_CONFIG = {
  TABLE_TITLE: "标签管理",
  STORAGE_KEY: "tags-table-columns",
};

// 搜索配置常量
export const SEARCH_CONFIG = {
  SEARCH_TITLE: "标签搜索",
  DEFAULT_COLUMNS: 4,
  COLLAPSIBLE: true,
  DEFAULT_COLLAPSED: false,
  LABEL_WIDTH: 100,
};

// 表格面板按钮配置（用于 ContainerPanel）
export const createTablePanelButtons = (handlers: {
  loadTags: () => void;
  handleCreate: () => void;
}): ButtonConfig[] => [
  {
    key: "refresh",
    text: "刷新",
    icon: <ReloadOutlined />,
    onClick: () => {
      handlers.loadTags();
    },
    group: "primary",
  },
  {
    key: "create",
    text: "新建",
    icon: <PlusOutlined />,
    type: "primary",
    onClick: () => {
      handlers.handleCreate();
    },
    group: "primary",
  },
];

// 创建表格列配置
export const createTableColumns = ({
  handleEdit,
  handleDelete,
}: {
  handleEdit: (tag: Tag) => void;
  handleDelete: (id: string) => void;
}): ColumnsType<Tag> => [
  {
    title: "标签名称",
    dataIndex: "name",
    key: "name",
    width: 200,
    fixed: "left",
    ellipsis: true,
    render: (text: string) => <AntTag style={{ margin: 0 }}>{text}</AntTag>,
  },
  {
    title: "图标",
    dataIndex: "icon",
    key: "icon",
    width: 100,
    align: "center" as const,
    render: (icon: string) => {
      return (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {icon ? (
            <div
              className="tag-icon-container"
              dangerouslySetInnerHTML={{ __html: icon }}
              style={{
                width: 16,
                height: 16,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            />
          ) : (
            <FileImageOutlined style={{ color: "#d9d9d9", fontSize: 16 }} />
          )}
        </div>
      );
    },
  },
  {
    title: "描述",
    dataIndex: "description",
    key: "description",
    ellipsis: true,
    render: (text: string) => text || <span style={{ color: "#999" }}>-</span>,
  },
  {
    title: "创建时间",
    dataIndex: "createdAt",
    key: "createdAt",
    width: 180,
    render: (text: string) => dayjs(text).format("YYYY-MM-DD HH:mm:ss"),
  },
  {
    title: "更新时间",
    dataIndex: "updatedAt",
    key: "updatedAt",
    width: 180,
    render: (text: string) => dayjs(text).format("YYYY-MM-DD HH:mm:ss"),
  },
  {
    title: "操作",
    key: "action",
    width: 100,
    fixed: "right",
    render: (_, record: Tag) => (
      <Space size={4}>
        <Tooltip title="编辑标签">
          <Button
            type="link"
            size="small"
            icon={<EditOutlined />}
            onClick={() => handleEdit(record)}
            style={{ padding: "4px 8px" }}
          />
        </Tooltip>
        <Popconfirm
          title="确认删除"
          description="确定要删除这个标签吗？"
          okText="确认"
          cancelText="取消"
          onConfirm={() => handleDelete(record.id)}
        >
          <Tooltip title="删除标签">
            <Button
              type="link"
              size="small"
              danger
              icon={<DeleteOutlined />}
              style={{ padding: "4px 8px" }}
            />
          </Tooltip>
        </Popconfirm>
      </Space>
    ),
  },
];
